import { createStyles } from '@material-ui/core';

const styles = createStyles({
  root: {
    width: 'max-content',
    minWidth: 'max-content'
  },
  '@media print': {
    root: {
      minWidth: '300px'
    }
  }
});

export default styles;
